import React, { Component } from "react";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import { Link } from "react-router-dom";
import { withRouter } from "../withRouter";
import {
  authVoter,
  getEventByUrl,
  getEventColors,
  getVoterByLink,
  getLandingPageConfigByEventUrl,
  sendContactForm,
} from "../api";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";
import VoterNavBar from "./VoterNavBar.js";
import { withTheme } from "../withTheme";
import bandesPhoviaH from "../assets/bandes_phovia_h.svg";
import videoIcon from "../assets/noun-video-clip-302012.svg";
import qaIcon from "../assets/noun-q-and-a-4074617.svg";
import { BASE_URL } from "../config";
import LoadingButton from "./LoadingButton";
import IntroScrollBox from "./IntroScrollBox";

class Voter extends Component {
  state = {
    username: "",
    event: null,
    showAlert: "",
    loading: true,
    showRegister: true,
    landingConfig: null,
    showContactForm: false,
    contactFormData: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },
    contactFormSending: false,
    contactFormAlert: "",
    isMobile: window.innerWidth <= 768,
    showVideoModal: false,
  };
  vh = window.innerHeight * 0.01;

  async componentDidMount() {
    this.setVHValue();
    window.addEventListener("resize", this.setVHValue);

    this.setState({ loading: true });
    try {
      const event = await getEventByUrl(this.props.params.unique_str);
      console.log("event", event);
      const colors = await getEventColors(event.id);

      // Récupérer la configuration de landing page
      let landingConfig = null;
      try {
        landingConfig = await getLandingPageConfigByEventUrl(
          this.props.params.unique_str
        );
      } catch (configError) {
        console.log("No landing page config found, using defaults");
        landingConfig = {
          show_experts_carousel: false,
          show_contact_form: false,
          show_vimeo_video: false,
          landing_experts: [],
        };
      }

      this.setState({ event, colors, landingConfig, loading: false });
    } catch (error) {
      let error_msg = "";
      if (error.response && error.response.data)
        error_msg = error.response.data.detail;
      else error_msg = error.message;
      this.setState({
        error: error_msg,
        showAlert: "danger",
        loading: false,
      });
    }
  }
  componentWillUnmount() {
    // Remove the event listener when the component is unmounted
    window.removeEventListener("resize", this.setVHValue);
  }
  setVHValue = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    // Mettre à jour isMobile en fonction de la nouvelle taille
    const isMobile = window.innerWidth <= 768;
    if (this.state.isMobile !== isMobile) {
      this.setState({ isMobile });
    }
  };
  handleChange = (event) => {
    this.setState({
      username: event.target.value,
    });
  };

  handleContactFormChange = (field, value) => {
    this.setState({
      contactFormData: {
        ...this.state.contactFormData,
        [field]: value,
      },
    });
  };

  handleContactFormSubmit = async (e) => {
    e.preventDefault();
    if (!this.state.landingConfig?.contact_email) return;

    this.setState({ contactFormSending: true });
    try {
      await sendContactForm(
        this.state.event.project_id,
        this.state.contactFormData
      );
      this.setState({
        contactFormAlert: "success",
        contactFormData: { name: "", email: "", subject: "", message: "" },
        showContactForm: false,
      });
    } catch (error) {
      this.setState({ contactFormAlert: "danger" });
    } finally {
      this.setState({ contactFormSending: false });
    }
  };

  handleSubmit = async () => {
    this.setState({ loading: true });
    try {
      // RECONNEXION (bouton "Resume your session") : en mode presenter, handleSubmit
      // n'est appelé QUE pour reprendre une session existante (le bouton "Start your
      // vote" navigue directement vers /voter/register). Le votant s'authentifie par
      // son username (pas par lien) et doit revenir DIRECTEMENT sur le vote, sans
      // repasser par l'intro/questionnaire.
      if (this.state.event.with_presenter) {
        try {
          await authVoter(
            this.state.event.id,
            this.state.username,
            this.props.params.unique_user_link
          );
        } catch (err) {
          // Username inconnu pour cet event -> message d'erreur, on reste sur l'accueil
          this.setState({
            loading: false,
            showAlert: "danger",
            error:
              this.state.event.langage === "fr"
                ? "Pseudo introuvable pour cet événement. Vérifiez votre saisie."
                : "Username not found for this event. Please check your entry.",
          });
          return;
        }
        this.setState({ loading: false });
        this.props.navigate(
          "/events/" + this.props.params.unique_str + "/voter/session"
        );
        return;
      }

      // L'intro à l'entrée ne concerne que la position "before_questionnaire" :
      // en "after_questionnaire" elle est affichée par VoterSession après la
      // dernière assertion, l'entrée suit donc le flux sans intro plus bas.
      const introPosition =
        this.state.event.intro_message_position || "before_questionnaire";
      if (
        this.state.event.show_first_page &&
        introPosition === "before_questionnaire"
      ) {
        // Vérifier si les questions sont déjà répondues
        // Pre-filter is always at start
        if (
          !this.state.event.with_presenter &&
          this.props.params.unique_user_link
        ) {
          const answersOk = await getVoterByLink(
            this.state.event.id,
            this.props.params.unique_user_link
          );

          if (answersOk.questions_mandatory) {
            // Le voter a déjà répondu aux questions, aller directement vers la session
            await authVoter(
              this.state.event.id,
              this.state.username,
              this.props.params.unique_user_link
            );
            this.setState({ loading: false });
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/session"
            );
            return;
          }
        }

        // Sinon, aller vers la page d'intro comme prévu
        this.setState({ loading: false });
        this.props.navigate(
          "/events/" + this.props.params.unique_str + "/voter/intro",
          {
            state: {
              unique_user_link: this.props.params.unique_user_link,
              event_id: this.state.event.id,
              langage: this.state.event.langage,
              form_placement: this.state.event.form_placement,
              base_questionnaire_placement: this.state.event.base_questionnaire_placement || "start",
              event_refused_message: this.state.event.event_refused_message,
              with_presenter: this.state.event.with_presenter,
              unique_str: this.props.params.unique_str,
              legal_notice: this.state.event.legal_notice,
            },
          }
        );
        return;
      }

      // Cas non-presenter (votant identifié par lien) : la reconnexion with_presenter
      // a déjà été traitée et a fait un return plus haut.
      {
        // Check base_questionnaire_placement - if "end", skip questionnaire at start
        const baseQuestionnairePlacement = this.state.event.base_questionnaire_placement || "start";

        if (baseQuestionnairePlacement === "end") {
          // Base questionnaire is after voting, go directly to session
          await authVoter(
            this.state.event.id,
            this.state.username,
            this.props.params.unique_user_link
          );
          this.props.navigate(
            "/events/" + this.props.params.unique_str + "/voter/session"
          );
        } else {
          // Base questionnaire is at start - check if already answered
          const answersOk = await getVoterByLink(
            this.state.event.id,
            this.props.params.unique_user_link
          );
          if (answersOk.questions_mandatory) {
            // Pre-filter already answered, go to session
            await authVoter(
              this.state.event.id,
              this.state.username,
              this.props.params.unique_user_link
            );
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/session"
            );
          } else {
            // Go to pre-filter questionnaire
            this.props.navigate(
              "/events/" + this.props.params.unique_str + "/voter/register",
              {
                state: {
                  event_id: this.state.event.id,
                  langage: this.state.event.langage,
                  form_placement: this.state.event.form_placement,
                  base_questionnaire_placement: baseQuestionnairePlacement,
                  position: "start",
                  unique_link: this.props.params.unique_user_link,
                  event_refused_message: this.state.event.event_refused_message,
                  with_presenter: this.state.event.with_presenter,
                  unique_str: this.props.params.unique_str,
                  legal_notice: this.state.event.legal_notice,
                  post_filter_questionnaire_enabled: this.state.event.post_filter_questionnaire_enabled,
                  questionnaire_type: "filter",
                },
              }
            );
          }
        }
      }
    } catch (error) {
      this.setState({
        error: error.response.data.detail,
        showAlert: "danger",
        loading: false,
      });
    }
  };

  // Composant pour le carrousel d'experts
  renderExpertsCarousel = () => {
    const { landingConfig } = this.state;
    const { colors } = this.state;

    if (
      !landingConfig?.show_experts_carousel ||
      !landingConfig?.landing_experts?.length
    ) {
      return null;
    }

    // Grouper les experts par paires de 2
    const expertPairs = [];
    for (let i = 0; i < landingConfig.landing_experts.length; i += 2) {
      expertPairs.push(landingConfig.landing_experts.slice(i, i + 2));
    }

    // Générer un ID unique pour ce carousel
    const carouselId = `experts-carousel-${Date.now()}`;

    return (
      <>
        {/* CSS personnalisé pour les contrôles du carousel */}
        <style>
          {`
            #${carouselId} .carousel-control-prev,
            #${carouselId} .carousel-control-next {
              background: none;
              border: none;
              width: 50px;
              height: 50px;
              top: 50%;
              transform: translateY(-50%);
              opacity: 0.8;
              transition: all 0.3s ease;
            }
            
            #${carouselId} .carousel-control-prev {
              left: -10px;
            }
            
            #${carouselId} .carousel-control-next {
              right: -10px;
            }
            
            #${carouselId} .carousel-control-prev:hover,
            #${carouselId} .carousel-control-next:hover {
              opacity: 1;
              transform: translateY(-50%) scale(1.1);
            }
            
            #${carouselId} .carousel-control-prev-icon,
            #${carouselId} .carousel-control-next-icon {
              background-image: none;
              width: 24px;
              height: 24px;
              position: relative;
            }
            
            #${carouselId} .carousel-control-prev-icon::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(45deg);
              width: 12px;
              height: 12px;
              border-left: 3px solid ${
                colors?.header_background_color || "#2d3748"
              };
              border-bottom: 3px solid ${
                colors?.header_background_color || "#2d3748"
              };
            }
            
            #${carouselId} .carousel-control-next-icon::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-135deg);
              width: 12px;
              height: 12px;
              border-left: 3px solid ${
                colors?.header_background_color || "#2d3748"
              };
              border-bottom: 3px solid ${
                colors?.header_background_color || "#2d3748"
              };
            }
            
            #${carouselId} .carousel-indicators {
              margin-bottom: 0;
              bottom: -30px;
              position: absolute;
              /* Beaucoup de slides dans une colonne étroite : passer à la
                 ligne au lieu de laisser flex écraser les points */
              flex-wrap: wrap;
              row-gap: 4px;
            }

            #${carouselId} .carousel-indicators button {
              background-color: ${colors?.header_background_color || "#2d3748"};
              opacity: 0.4;
              width: 8px;
              height: 8px;
              border-radius: 50%;
              margin: 0 3px;
              /* flex-shrink de Bootstrap compressait les points (8px -> <1px,
                 rendu en barres verticales) dès ~12 slides */
              flex: 0 0 auto;
              transition: all 0.3s ease;
            }
            
            #${carouselId} .carousel-indicators button.active {
              background-color: ${colors?.header_background_color || "#2d3748"};
              opacity: 1;
              transform: scale(1.2);
            }
          `}
        </style>

        <div
          style={{
            padding: "0 24px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Carousel
              id={carouselId}
              indicators={true}
              controls={expertPairs.length > 1}
              interval={5000}
              style={{ width: "100%" }}
            >
              {expertPairs.map((expertPair, pairIndex) => (
                <Carousel.Item key={pairIndex}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      minHeight: "350px",
                      padding: "10px 20px",
                      gap: "24px",
                    }}
                  >
                    {expertPair.map((expert, expertIndex) => (
                      <div
                        key={expertIndex}
                        style={{
                          textAlign: "center",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        {expert.photo_url && (
                          <div
                            style={{
                              width: "90px",
                              height: "110px",
                              borderRadius: "16px",
                              overflow: "hidden",
                              marginBottom: "12px",
                              border: "3px solid #f7fafc",
                              boxShadow: "0 6px 20px rgba(0, 0, 0, 0.12)",
                            }}
                          >
                            <img
                              src={`${BASE_URL}/projects/${this.state.event?.project_id}/experts/${expert.photo_url}`}
                              alt={expert.name}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}

                        <h6
                          style={{
                            margin: "0 0 4px 0",
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#2d3748",
                          }}
                        >
                          {expert.name}
                        </h6>

                        {expert.title && (
                          <p
                            style={{
                              margin: "0 0 2px 0",
                              fontSize: "12px",
                              color: "#718096",
                              fontWeight: "500",
                            }}
                          >
                            {expert.title}
                          </p>
                        )}

                        {expert.specialty && (
                          <p
                            style={{
                              margin: "0",
                              fontSize: "11px",
                              color: "#a0aec0",
                            }}
                          >
                            {expert.specialty}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>
        </div>
      </>
    );
  };

  // Composant pour la vidéo Vimeo
  renderVimeoVideo = () => {
    const { landingConfig } = this.state;
    if (!landingConfig?.show_vimeo_video || !landingConfig?.vimeo_video_id) {
      return null;
    }

    return (
      <div
        style={{
          padding: "0 8px 24px 8px",
          flexShrink: 0,
        }}
      >
        <div
          style={{
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* Icône vidéo */}
          <img
            src={videoIcon}
            alt="Vidéo"
            style={{ width: "32px", height: "32px" }}
          />
          <h6
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: this.state.colors?.header_background_color || "#2d3748",
            }}
          >
            {landingConfig.vimeo_video_title || "Vidéo de présentation"}
          </h6>
        </div>
        <div
          onClick={() => this.setState({ showVideoModal: true })}
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            transition: "transform 0.2s ease",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <img
            src={
              landingConfig.vimeo_video_thumbnail_url
                ? `${BASE_URL}/projects/${this.state.event?.project_id}/data/vimeo_thumbnail`
                : `https://vumbnail.com/${landingConfig.vimeo_video_id}.jpg`
            }
            alt="Aperçu vidéo"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          {/* Bouton play superposé */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "60px",
              height: "60px",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="white"
              style={{ marginLeft: "2px" }}
            >
              <polygon points="5,3 19,12 5,21"></polygon>
            </svg>
          </div>
        </div>
      </div>
    );
  };

  // Composant pour le formulaire de contact
  renderContactForm = () => {
    const {
      landingConfig,
      showContactForm,
      contactFormData,
      contactFormSending,
    } = this.state;
    const lang = this.state.event?.langage;

    if (!landingConfig?.show_contact_form || !landingConfig?.contact_email) {
      return null;
    }

    const translations = {
      contact: lang === "fr" ? "Contact" : "Contact",
      name: lang === "fr" ? "Nom" : "Name",
      email: lang === "fr" ? "Email" : "Email",
      subject: lang === "fr" ? "Sujet" : "Subject",
      message: lang === "fr" ? "Message" : "Message",
      send: lang === "fr" ? "Envoyer" : "Send",
      close: lang === "fr" ? "Fermer" : "Close",
    };

    return (
      <>
        <div
          style={{
            padding: "0 8px 24px 8px",
            textAlign: "left",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <div
            style={{
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* Icône Q&A */}
            <img
              src={qaIcon}
              alt="Q&A"
              style={{ width: "32px", height: "32px" }}
            />
            <h5
              style={{
                margin: "0",
                fontSize: "20px",
                fontWeight: "600",
                color: this.state.colors?.header_background_color || "#2d3748",
              }}
            >
              {landingConfig.contact_form_title || translations.contact}
            </h5>
          </div>
          <button
            onClick={() => this.setState({ showContactForm: true })}
            style={{
              backgroundColor: "transparent",
              border: "2px solid #e2e8f0",
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#4a5568",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "100%",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#f7fafc";
              e.target.style.borderColor = "#cbd5e0";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.borderColor = "#e2e8f0";
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            {translations.contact}
          </button>
        </div>

        <Modal
          show={showContactForm}
          onHide={() => this.setState({ showContactForm: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {landingConfig.contact_form_title || translations.contact}
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleContactFormSubmit}>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>{translations.name}</Form.Label>
                <Form.Control
                  type="text"
                  value={contactFormData.name}
                  onChange={(e) =>
                    this.handleContactFormChange("name", e.target.value)
                  }
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.email}</Form.Label>
                <Form.Control
                  type="email"
                  value={contactFormData.email}
                  onChange={(e) =>
                    this.handleContactFormChange("email", e.target.value)
                  }
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.subject}</Form.Label>
                <Form.Control
                  type="text"
                  value={contactFormData.subject}
                  onChange={(e) =>
                    this.handleContactFormChange("subject", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.message}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={contactFormData.message}
                  onChange={(e) =>
                    this.handleContactFormChange("message", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.setState({ showContactForm: false })}
              >
                {translations.close}
              </Button>
              <LoadingButton
                variant="primary"
                type="submit"
                loading={contactFormSending}
              >
                {translations.send}
              </LoadingButton>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  };

  renderExpertsCarouselMobile = () => {
    const { landingConfig } = this.state;

    if (
      !landingConfig?.show_experts_carousel ||
      !landingConfig?.landing_experts?.length
    ) {
      return null;
    }

    return (
      <div style={{ padding: "0 24px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "20px",
            justifyItems: "center",
          }}
        >
          {landingConfig.landing_experts.map((expert, index) => (
            <div
              key={index}
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {expert.photo_url && (
                <div
                  style={{
                    width: "80px",
                    height: "100px",
                    borderRadius: "12px",
                    overflow: "hidden",
                    marginBottom: "12px",
                    border: "2px solid #f7fafc",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <img
                    src={`${BASE_URL}/projects/${this.state.event?.project_id}/experts/${expert.photo_url}`}
                    alt={expert.name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              )}

              <h6
                style={{
                  margin: "0 0 4px 0",
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#2d3748",
                }}
              >
                {expert.name}
              </h6>

              {expert.title && (
                <p
                  style={{
                    margin: "0 0 2px 0",
                    fontSize: "11px",
                    color: "#718096",
                    fontWeight: "500",
                  }}
                >
                  {expert.title}
                </p>
              )}

              {expert.specialty && (
                <p
                  style={{
                    margin: "0",
                    fontSize: "10px",
                    color: "#a0aec0",
                  }}
                >
                  {expert.specialty}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  renderVimeoVideoMobile = () => {
    const { landingConfig } = this.state;
    if (!landingConfig?.show_vimeo_video || !landingConfig?.vimeo_video_id) {
      return null;
    }

    return (
      <div style={{ padding: "0 24px" }}>
        <div
          style={{
            marginBottom: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* Icône vidéo */}
          <img
            src={videoIcon}
            alt="Vidéo"
            style={{ width: "32px", height: "32px" }}
          />
          <h5
            style={{
              margin: "0",
              fontSize: "20px",
              fontWeight: "600",
              color: this.state.colors?.header_background_color || "#2d3748",
            }}
          >
            {landingConfig.vimeo_video_title || "Vidéo de présentation"}
          </h5>
        </div>
        <div
          onClick={() => this.setState({ showVideoModal: true })}
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            cursor: "pointer",
            transition: "transform 0.2s ease",
          }}
          onTouchStart={(e) => {
            e.currentTarget.style.transform = "scale(1.02)";
          }}
          onTouchEnd={(e) => {
            e.currentTarget.style.transform = "scale(1)";
          }}
        >
          <img
            src={
              landingConfig.vimeo_video_thumbnail_url
                ? `${BASE_URL}/projects/${this.state.event?.project_id}/data/vimeo_thumbnail`
                : `https://vumbnail.com/${landingConfig.vimeo_video_id}.jpg`
            }
            alt="Aperçu vidéo"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
          {/* Bouton play superposé */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "60px",
              height: "60px",
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s ease",
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="white"
              style={{ marginLeft: "2px" }}
            >
              <polygon points="5,3 19,12 5,21"></polygon>
            </svg>
          </div>
        </div>
      </div>
    );
  };

  renderContactFormMobile = () => {
    const {
      landingConfig,
      showContactForm,
      contactFormData,
      contactFormSending,
    } = this.state;
    const lang = this.state.event?.langage;

    if (!landingConfig?.show_contact_form || !landingConfig?.contact_email) {
      return null;
    }

    const translations = {
      contact: lang === "fr" ? "Contact" : "Contact",
      name: lang === "fr" ? "Nom" : "Name",
      email: lang === "fr" ? "Email" : "Email",
      subject: lang === "fr" ? "Sujet" : "Subject",
      message: lang === "fr" ? "Message" : "Message",
      send: lang === "fr" ? "Envoyer" : "Send",
      close: lang === "fr" ? "Fermer" : "Close",
    };

    return (
      <>
        <div style={{ padding: "0 24px" }}>
          <div
            style={{
              marginBottom: "24px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* Icône Q&A */}
            <img
              src={qaIcon}
              alt="Q&A"
              style={{ width: "32px", height: "32px" }}
            />
            <h5
              style={{
                margin: "0",
                fontSize: "20px",
                fontWeight: "600",
                color: this.state.colors?.header_background_color || "#2d3748",
                textAlign: "left",
              }}
            >
              {landingConfig.contact_form_title || translations.contact}
            </h5>
          </div>
          <button
            onClick={() => this.setState({ showContactForm: true })}
            style={{
              backgroundColor: "transparent",
              border: "2px solid #e2e8f0",
              borderRadius: "12px",
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#4a5568",
              cursor: "pointer",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              width: "100%",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#f7fafc";
              e.target.style.borderColor = "#cbd5e0";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.borderColor = "#e2e8f0";
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
              <polyline points="22,6 12,13 2,6" />
            </svg>
            {translations.contact}
          </button>
        </div>

        <Modal
          show={showContactForm}
          onHide={() => this.setState({ showContactForm: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {landingConfig.contact_form_title || translations.contact}
            </Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleContactFormSubmit}>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>{translations.name}</Form.Label>
                <Form.Control
                  type="text"
                  value={contactFormData.name}
                  onChange={(e) =>
                    this.handleContactFormChange("name", e.target.value)
                  }
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.email}</Form.Label>
                <Form.Control
                  type="email"
                  value={contactFormData.email}
                  onChange={(e) =>
                    this.handleContactFormChange("email", e.target.value)
                  }
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.subject}</Form.Label>
                <Form.Control
                  type="text"
                  value={contactFormData.subject}
                  onChange={(e) =>
                    this.handleContactFormChange("subject", e.target.value)
                  }
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>{translations.message}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  value={contactFormData.message}
                  onChange={(e) =>
                    this.handleContactFormChange("message", e.target.value)
                  }
                  required
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => this.setState({ showContactForm: false })}
              >
                {translations.close}
              </Button>
              <LoadingButton
                variant="primary"
                type="submit"
                loading={contactFormSending}
              >
                {translations.send}
              </LoadingButton>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  };

  // Détermine si une couleur hex est claire (luminance élevée) pour choisir
  // une couleur de texte lisible. Retourne true si la couleur est claire.
  isLightColor(hex) {
    if (!hex) return true;
    let c = hex.replace("#", "").trim();
    if (c.length === 3) {
      c = c
        .split("")
        .map((ch) => ch + ch)
        .join("");
    }
    if (c.length !== 6) return false;
    const r = parseInt(c.substring(0, 2), 16);
    const g = parseInt(c.substring(2, 4), 16);
    const b = parseInt(c.substring(4, 6), 16);
    // Luminance perçue (ITU-R BT.601)
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.7;
  }

  render() {
    const {
      event,
      colors,
      showAlert,
      error,
      loading,
      username,
      landingConfig,
      isMobile,
    } = this.state;
    const lang = event?.langage;
    const translations = {
      welcome:
        lang === "fr"
          ? "Bienvenue sur la plateforme de vote Delphi."
          : "Welcome to DELPHI voting.",
      register:
        lang === "fr"
          ? "Si vous ne vous êtes pas encore connecté(e) à la plateforme, vous pouvez vous inscrire :"
          : "If you haven't registered to the event yet:",
      enterUsername: this.state.showRegister
        ? lang === "fr"
          ? "Si vous vous êtes déjà inscrit(e), vous pouvez reprendre votre session de vote Delphi en rentrant le pseudo choisi lors de votre inscription :"
          : "Please enter your username if you have been disconnected to resume your session:"
        : lang === "fr"
        ? "Entrez votre pseudo pour reprendre votre session de vote Delphi:"
        : "Enter your username to resume your voting session:",
      usernamePlaceholder: lang === "fr" ? "Nom d'utilisateur" : "Username",
      enter:
        lang === "fr"
          ? event?.with_presenter
            ? "Reprendre votre session"
            : "Démarrer"
          : event?.with_presenter
          ? "Resume your session"
          : "Start your vote",
      registerButton: lang === "fr" ? "Commencer" : "Start your vote",
      error: lang === "fr" ? "Erreur" : "Error",
      success: lang === "fr" ? "Succès" : "Success",
      close: lang === "fr" ? "Fermer" : "Close",
    };

    if (loading) {
      return (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            minHeight: "100vh",
            backgroundColor: colors?.background_color,
          }}
        >
          <Spinner animation="grow" variant="primary" />
        </div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: isMobile ? "auto" : "100vh",
          minHeight: isMobile ? "100vh" : "auto",
          backgroundColor: colors?.background_color,
        }}
      >
        {/* Header avec titre */}
        <div
          style={{
            backgroundColor: colors?.header_background_color,
            borderBottom: "1px solid #e0e0e0",
            padding: isMobile ? "12px 0" : "16px 0",
          }}
        >
          <Container
            className={
              isMobile
                ? ""
                : "d-flex align-items-center justify-content-between"
            }
            style={{
              display: isMobile ? "flex" : undefined,
              flexDirection: isMobile ? "column" : undefined,
              alignItems: isMobile ? "center" : undefined,
              textAlign: isMobile ? "center" : undefined,
              gap: isMobile ? "12px" : undefined,
            }}
          >
            {isMobile ? (
              // Version mobile - disposition en colonne
              <>
                {/* Logo en haut */}
                {landingConfig?.show_header_logo !== false && (
                  <div style={{ flexShrink: 0 }}>
                    {landingConfig?.header_logo_url ? (
                      <img
                        src={`${BASE_URL}/projects/${event?.project_id}/data/header_logo`}
                        alt="Logo"
                        style={{
                          height: "86px",
                          objectFit: "contain",
                        }}
                        onError={(e) => {
                          e.target.style.display = "none";
                        }}
                      />
                    ) : (
                      event && (
                        <img
                          src={`${BASE_URL}/events/${event.id}/data/logo`}
                          alt="Logo"
                          style={{
                            height: "86px",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      )
                    )}
                  </div>
                )}

                {/* Titre en dessous */}
                <div>
                  <h1
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "700",
                      color:
                        colors?.header_background_color === "#ffffff" ||
                        colors?.header_background_color === "white"
                          ? "#1a202c"
                          : "white",
                      margin: 0,
                      lineHeight: "1.2",
                    }}
                  >
                    {event?.event_title}
                  </h1>
                </div>
              </>
            ) : (
              // Version desktop - disposition en ligne
              <>
                {/* Logo à gauche */}
                <div style={{ flexShrink: 0 }}>
                  {landingConfig?.show_header_logo !== false && (
                    <>
                      {landingConfig?.header_logo_url ? (
                        <img
                          src={`${BASE_URL}/projects/${event?.project_id}/data/header_logo`}
                          alt="Logo"
                          style={{
                            height: "86px",
                            objectFit: "contain",
                          }}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      ) : (
                        event && (
                          <img
                            src={`${BASE_URL}/events/${event.id}/data/logo`}
                            alt="Logo"
                            style={{
                              height: "86px",
                              objectFit: "contain",
                            }}
                            onError={(e) => {
                              e.target.style.display = "none";
                            }}
                          />
                        )
                      )}
                    </>
                  )}
                </div>

                {/* Titre au centre */}
                <div
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "0 40px",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "1.8rem",
                      fontWeight: "700",
                      color:
                        colors?.header_background_color === "#ffffff" ||
                        colors?.header_background_color === "white"
                          ? "#1a202c"
                          : "white",
                      margin: 0,
                      lineHeight: "1.2",
                    }}
                  >
                    {event?.event_title}
                  </h1>
                </div>

                {/* Espace pour équilibrer (même largeur que le logo) */}
                <div
                  style={{
                    width: "60px",
                    flexShrink: 0,
                  }}
                ></div>
              </>
            )}
          </Container>
        </div>

        {/* Contenu principal */}
        {isMobile ? (
          // VERSION MOBILE - Structure simple
          <Container className="py-4" style={{ paddingBottom: "100px" }}>
            {/* Alert */}
            {showAlert !== "" && (
              <Alert
                show={showAlert !== ""}
                variant={showAlert}
                className="mb-4"
              >
                <Alert.Heading>
                  {showAlert === "danger"
                    ? translations.error
                    : translations.success}
                </Alert.Heading>
                <p>{error}</p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => this.setState({ showAlert: "" })}
                    variant={"outline-" + showAlert}
                  >
                    {translations.close}
                  </Button>
                </div>
              </Alert>
            )}

            {/* Experts */}
            {landingConfig?.show_experts_carousel &&
              landingConfig?.landing_experts?.length > 0 && (
                <div style={{ marginBottom: "32px" }}>
                  {this.renderExpertsCarouselMobile()}
                </div>
              )}

            {/* Carte principale */}
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "20px",
                padding: "32px 24px",
                boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                border: "1px solid #f0f0f0",
                marginBottom: "32px",
                minHeight: "400px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Contenu textuel avec scroll */}
              {(event?.event_subtitle || event?.event_description) && (
                <IntroScrollBox
                  maxHeight="300px"
                  style={{ marginBottom: "32px" }}
                >
                  {event?.event_subtitle && (
                    <h2
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "400",
                        color: "#718096",
                        marginBottom: "24px",
                        lineHeight: "1.4",
                      }}
                    >
                      {event?.event_subtitle}
                    </h2>
                  )}
                  {event?.event_description && (
                    <div
                      style={{
                        fontSize: "1rem",
                        color: "#4a5568",
                        lineHeight: "1.6",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: event?.event_description,
                      }}
                    />
                  )}
                </IntroScrollBox>
              )}

              {/* Actions */}
              <div style={{ marginTop: "auto" }}>
                {event?.with_presenter && (
                  <div style={{ marginBottom: "32px" }}>
                    <button
                      onClick={() =>
                        this.props.navigate(
                          `/events/${this.props.params.unique_str}/voter/register`,
                          {
                            state: {
                              event_id: event.id,
                              langage: event.langage,
                              form_placement: event.form_placement,
                              base_questionnaire_placement: event.base_questionnaire_placement || "start",
                              position: "start",
                              unique_link: this.props.params.unique_user_link,
                              event_refused_message:
                                event.event_refused_message,
                              with_presenter: event.with_presenter,
                              unique_str: this.props.params.unique_str,
                              legal_notice: event.legal_notice,
                              post_filter_questionnaire_enabled: event.post_filter_questionnaire_enabled,
                              questionnaire_type: "filter",
                            },
                          }
                        )
                      }
                      style={{
                        width: "100%",
                        backgroundColor:
                          colors?.header_background_color || "#2d3748",
                        color: "white",
                        border: "none",
                        borderRadius: "16px",
                        padding: "18px 28px",
                        fontSize: "16px",
                        fontWeight: "600",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                        minHeight: "54px",
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polygon points="5,3 19,12 5,21 5,3"></polygon>
                      </svg>
                      {translations.registerButton}
                    </button>
                  </div>
                )}

                {event?.with_presenter && (
                  <div style={{ marginBottom: "24px", textAlign: "center" }}>
                    <p
                      style={{
                        margin: "0",
                        fontSize: "16px",
                        color: "#718096",
                        fontWeight: "700",
                      }}
                    >
                      OR
                    </p>
                  </div>
                )}

                <Form>
                  {event?.with_presenter && (
                    <div style={{ marginBottom: "24px" }}>
                      <label
                        style={{
                          display: "block",
                          marginBottom: "8px",
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#4a5568",
                        }}
                      >
                        {translations.enterUsername}
                      </label>
                      <Form.Control
                        required
                        type="text"
                        name="username"
                        value={username}
                        onChange={this.handleChange}
                        autoCapitalize="none"
                        autoCorrect="off"
                        spellCheck={false}
                        style={{
                          border: "2px solid #e2e8f0",
                          borderRadius: "12px",
                          padding: "16px 18px",
                          fontSize: "16px",
                          minHeight: "50px",
                        }}
                      />
                    </div>
                  )}

                  <LoadingButton
                    onClick={this.handleSubmit.bind(this)}
                    variant="secondary"
                    size="lg"
                    style={{
                      backgroundColor: colors?.background_color || "#48bb78",
                      border: this.isLightColor(colors?.background_color)
                        ? "2px solid #cbd5e0"
                        : "none",
                      borderRadius: "14px",
                      padding: "18px 32px",
                      fontSize: "16px",
                      fontWeight: "600",
                      color: this.isLightColor(colors?.background_color)
                        ? "#333"
                        : "white",
                      width: "100%",
                      minHeight: "50px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                    }}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="23 4 23 10 17 10" />
                      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                    </svg>
                    {translations.enter}
                  </LoadingButton>
                </Form>
              </div>
            </div>

            {/* Contact et Vidéo */}
            {(landingConfig?.show_contact_form ||
              landingConfig?.show_vimeo_video) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                {this.renderVimeoVideoMobile()}
                {this.renderContactFormMobile()}
              </div>
            )}
          </Container>
        ) : (
          // VERSION DESKTOP - Layout en table pour plus de fiabilité
          <div
            style={{
              maxWidth: "1400px",
              margin: "0 auto",
              height: "calc(100vh - 100px)",
              display: "table",
              width: "100%",
              tableLayout: "fixed",
              padding: "20px",
            }}
          >
            {/* Alert */}
            {showAlert !== "" && (
              <Alert
                show={showAlert !== ""}
                variant={showAlert}
                style={{ marginBottom: "20px" }}
              >
                <Alert.Heading>
                  {showAlert === "danger"
                    ? translations.error
                    : translations.success}
                </Alert.Heading>
                <p>{error}</p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => this.setState({ showAlert: "" })}
                    variant={"outline-" + showAlert}
                  >
                    {translations.close}
                  </Button>
                </div>
              </Alert>
            )}

            <div
              style={{
                display: "table-row",
                height: "100%",
              }}
            >
              {/* Colonne gauche - Experts */}
              {landingConfig?.show_experts_carousel &&
                landingConfig?.landing_experts?.length > 0 && (
                  <div
                    style={{
                      display: "table-cell",
                      width: "200px",
                      verticalAlign: "middle",
                      paddingRight: "8px",
                    }}
                  >
                    {this.renderExpertsCarousel()}
                  </div>
                )}

              {/* Colonne centrale - Contenu principal */}
              <div
                style={{
                  display: "table-cell",
                  verticalAlign: "middle",
                  paddingLeft:
                    landingConfig?.show_experts_carousel &&
                    landingConfig?.landing_experts?.length > 0
                      ? "0"
                      : "0",
                  paddingRight:
                    landingConfig?.show_contact_form ||
                    landingConfig?.show_vimeo_video
                      ? "8px"
                      : "0",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "20px",
                    padding: "48px",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    border: "1px solid #f0f0f0",
                    maxWidth: "580px",
                    margin: "0 auto",
                    minHeight: "580px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Contenu textuel avec scroll */}
                  {(event?.event_subtitle || event?.event_description) && (
                    <IntroScrollBox
                      maxHeight="450px"
                      style={{ marginBottom: "48px" }}
                    >
                      {event?.event_subtitle && (
                        <h2
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "400",
                            color: "#718096",
                            marginBottom: "24px",
                            lineHeight: "1.4",
                          }}
                        >
                          {event?.event_subtitle}
                        </h2>
                      )}
                      {event?.event_description && (
                        <div
                          style={{
                            fontSize: "1.1rem",
                            color: "#4a5568",
                            lineHeight: "1.6",
                            maxWidth: "480px",
                          }}
                          dangerouslySetInnerHTML={{
                            __html: event?.event_description,
                          }}
                        />
                      )}
                    </IntroScrollBox>
                  )}

                  {/* Actions */}
                  <div
                    style={{
                      marginTop: "auto",
                      maxWidth: "460px",
                    }}
                  >
                    {event?.with_presenter && (
                      <div style={{ marginBottom: "32px" }}>
                        <button
                          onClick={() =>
                            this.props.navigate(
                              `/events/${this.props.params.unique_str}/voter/register`,
                              {
                                state: {
                                  event_id: event.id,
                                  langage: event.langage,
                                  form_placement: event.form_placement,
                                  base_questionnaire_placement: event.base_questionnaire_placement || "start",
                                  position: "start",
                                  unique_link:
                                    this.props.params.unique_user_link,
                                  event_refused_message:
                                    event.event_refused_message,
                                  with_presenter: event.with_presenter,
                                  unique_str: this.props.params.unique_str,
                                  legal_notice: event.legal_notice,
                                  post_filter_questionnaire_enabled: event.post_filter_questionnaire_enabled,
                                  questionnaire_type: "filter",
                                },
                              }
                            )
                          }
                          style={{
                            width: "100%",
                            backgroundColor:
                              colors?.header_background_color || "#2d3748",
                            color: "white",
                            border: "none",
                            borderRadius: "16px",
                            padding: "20px 32px",
                            fontSize: "18px",
                            fontWeight: "600",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "12px",
                          }}
                        >
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <polygon points="5,3 19,12 5,21 5,3"></polygon>
                          </svg>
                          {translations.registerButton}
                        </button>
                      </div>
                    )}

                    {event?.with_presenter && (
                      <div
                        style={{
                          marginBottom: "24px",
                          textAlign: "center",
                        }}
                      >
                        <p
                          style={{
                            margin: "0 0 20px 0",
                            fontSize: "16px",
                            color: "#718096",
                            fontWeight: "700",
                          }}
                        >
                          OR
                        </p>
                      </div>
                    )}

                    <Form>
                      {event?.with_presenter && (
                        <div style={{ marginBottom: "24px" }}>
                          <label
                            style={{
                              display: "block",
                              marginBottom: "8px",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#4a5568",
                            }}
                          >
                            {translations.enterUsername}
                          </label>
                          <Form.Control
                            required
                            type="text"
                            name="username"
                            value={username}
                            onChange={this.handleChange}
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck={false}
                            style={{
                              border: "2px solid #e2e8f0",
                              borderRadius: "12px",
                              padding: "14px 16px",
                              fontSize: "16px",
                            }}
                          />
                        </div>
                      )}

                      <LoadingButton
                        onClick={this.handleSubmit.bind(this)}
                        variant="secondary"
                        size="lg"
                        style={{
                          width: "100%",
                          backgroundColor:
                            colors?.background_color || "#48bb78",
                          border: this.isLightColor(colors?.background_color)
                            ? "2px solid #cbd5e0"
                            : "none",
                          borderRadius: "14px",
                          padding: "16px 40px",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: this.isLightColor(colors?.background_color)
                            ? "#333"
                            : "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "8px",
                        }}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="23 4 23 10 17 10" />
                          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
                        </svg>
                        {translations.enter}
                      </LoadingButton>
                    </Form>
                  </div>
                </div>
              </div>

              {/* Colonne droite - Contact et Vidéo */}
              {(landingConfig?.show_contact_form ||
                landingConfig?.show_vimeo_video) && (
                <div
                  style={{
                    display: "table-cell",
                    width: "450px",
                    verticalAlign: "middle",
                    paddingLeft: "10px",
                  }}
                >
                  <div>
                    {this.renderVimeoVideo()}
                    {this.renderContactForm()}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Footer discret */}
        {(landingConfig?.footer_logo_url ||
          landingConfig?.landing_footer_text ||
          event?.legal_notice) && (
          <footer
            style={{
              borderTop: "1px solid #f0f0f0",
              padding: "16px 0",
            }}
          >
            <Container style={{ maxWidth: "1400px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: isMobile ? "wrap" : "nowrap",
                  gap: isMobile ? "8px" : "0",
                }}
              >
                {/* Logo footer à gauche */}
                <div
                  style={{
                    flex: "0 0 auto",
                    maxWidth: isMobile ? "35%" : "auto",
                  }}
                >
                  {landingConfig?.footer_logo_url ? (
                    <img
                      src={`${BASE_URL}/projects/${event?.project_id}/data/footer_logo`}
                      alt="Footer Logo"
                      style={{
                        height: isMobile ? "28px" : "32px",
                        objectFit: "contain",
                        maxWidth: "100%",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <div></div>
                  )}
                </div>

                {/* Mentions à droite */}
                <div
                  style={{
                    flex: "0 0 auto",
                    textAlign: "right",
                    maxWidth: isMobile ? "60%" : "auto",
                  }}
                >
                  {landingConfig?.landing_footer_text && (
                    <div
                      style={{
                        marginBottom: event?.legal_notice ? "4px" : "0",
                      }}
                    >
                      <small
                        style={{
                          color: "#718096",
                          fontSize: isMobile ? "13px" : "14px",
                        }}
                      >
                        {landingConfig.landing_footer_text}
                      </small>
                    </div>
                  )}

                  {event?.legal_notice && (
                    <div>
                      <small
                        style={{
                          color: "#a0aec0",
                          fontSize: isMobile ? "11px" : "12px",
                        }}
                      >
                        {event.legal_notice}
                      </small>
                    </div>
                  )}
                </div>
              </div>
            </Container>
          </footer>
        )}

        {/* Modal vidéo plein écran */}
        {this.state.showVideoModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.85)",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
            }}
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                this.setState({ showVideoModal: false });
              }
            }}
          >
            {/* Bouton de fermeture */}
            <button
              onClick={() => this.setState({ showVideoModal: false })}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "2px solid rgba(255, 255, 255, 0.3)",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.2s ease",
                zIndex: 10000,
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                e.target.style.borderColor = "rgba(255, 255, 255, 0.5)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
                e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>

            {/* Conteneur vidéo */}
            <div
              style={{
                width: "100%",
                maxWidth: "90vw",
                maxHeight: "90vh",
                aspectRatio: "16/9",
                position: "relative",
              }}
            >
              <iframe
                src={`https://player.vimeo.com/video/${this.state.landingConfig?.vimeo_video_id}?title=0&byline=0&portrait=0&autoplay=1`}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Vimeo video"
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  borderRadius: "8px",
                }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(withTheme(Voter));
